import { all, fork } from 'redux-saga/effects';

import coreSaga from './core.saga';
import dashboardSaga from './dashboard.saga';

export default function* deviceSagas() {
  yield all([fork(coreSaga), fork(dashboardSaga)]);
}
